import { defineMessages } from 'react-intl';

export default defineMessages({
  seemore: {
    id: 'view.appStatus.seeMore',
    defaultMessage: 'See more',
  },
  scheduleTime: {
    id: 'view.appStatus.sheduledMaintenance.scheduleTime',
    defaultMessage: 'Time: {time} for {duration}',
  },
});
